// extracted by mini-css-extract-plugin
export default {"container":"card_container__KF5zT"};